/* eslint-disable @typescript-eslint/no-empty-interface */
import { client } from '../client';

interface UserWebState {}

// `gzipRequest: true` opts into the client.ts request-gzip interceptor.
// Requires the matching gzip-request middleware on the API (see
// dentistry-one-api `src/main.py`). Safe in browsers without
// CompressionStream — the interceptor falls back to plain JSON.
export const setUserWebState = async (state: UserWebState): Promise<any> => {
  const { data } = await client.post<any>(
    '/users/state',
    { state },
    { gzipRequest: true },
  );

  return data;
};
